import React from 'react';

import Alert from '@mui/material/Alert';
import { useFormContext } from 'react-hook-form';

import { CustomizedButton } from 'components/common';
import { FormProps } from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/UploadRisksModal';
import classes from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/UploadRisksModal.module.scss';

interface Props {
    partialSuccess: string[];
    closeModal: () => void;
}

export const PartialContent = ({ partialSuccess, closeModal }: Props) => {
    const form = useFormContext<FormProps>();

    const file = form.watch('file');

    return (
        <>
            <div className={classes.selectTitle}>Upload partially successful. Some rows include invalid input.</div>

            <div className={classes.fileName}>File: {file?.name}</div>
            <Alert severity="warning" className={classes.errorMessage}>
                {partialSuccess.map((item) => (
                    <div>{item}</div>
                ))}
            </Alert>
            <div className={classes.footer}>
                <div className={classes.container}>
                    <CustomizedButton size={'large'} color={'secondary'} onClick={closeModal}>
                        Close
                    </CustomizedButton>
                </div>
            </div>
        </>
    );
};
